// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ion-padding: 12px;
}

.full-width {
  width: 100%;
}

swiper-container {
  height: 100%;
}

.margin-top-value {
  margin-top: 10px;
}

ion-slides {
  width: 100% !important;
  height: 100% !important;
}

swiper-slide {
  overflow: auto;
}

ion-slide {
  width: 100% !important;
  padding: 10px;
}
ion-slide > ion-col {
  overflow: auto;
  top: 0;
  bottom: 0;
  position: absolute;
  padding: 20px;
  text-align: left;
}

@media (min-width: 991px) {
  ion-content {
    height: 80%;
  }
}

.form-row {
  padding: 5px 25px 20px;
  overflow-x: hidden;
}

.slots-row {
  padding: 5px 25px 20px;
  display: flex;
  flex-direction: column;
}
.slots-row h2 {
  color: white !important;
}

.form-card {
  background-color: var(--background-color);
  padding: 12px 6px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.phone-item {
  border: none;
}
.phone-item ion-input:first-child {
  margin-right: 10px;
}
.phone-item ion-input {
  margin-bottom: 5px;
  border-bottom: 1px solid var(--ion-color-dark);
}

.label-error {
  color: rgb(119, 25, 25);
}

ion-card {
  margin: 0;
  padding: 12px;
  border-radius: 0px;
  text-align: initial;
  --color: var(--ion-color-black);
  --preorder-type-chip-border-color: var(--ion-color-primary);
  overflow: auto;
  word-break: break-word;
  border: 0.5px solid #e2dcd5;
  box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.0588235294);
}
ion-card:first-of-type {
  margin-bottom: 10px;
}
ion-card ion-card-content {
  border-top: 0.5px solid #e2dcd5;
  padding: 0px;
  line-break: auto !important;
}
ion-card ion-card-content:first-of-type {
  border: none;
}
ion-card ion-card-content .padding-card {
  padding: 10px;
}
ion-card ion-col {
  padding: 0;
}

ion-card-header {
  background: white;
  color: var(--ion-color-black);
  padding: 0;
}
ion-card-header .separator {
  margin-block: 20px;
}
ion-card-header ion-button {
  --background: transparent;
  --color: #54504c;
  border: 1.5px solid white;
  text-transform: none;
}

.left-col {
  font-family: AppFontBold;
  font-size: 13px;
  line-height: 16px;
  text-align: left;
  color: #000;
}
@media (min-width: 991px) {
  .left-col {
    font-size: 16px;
    line-height: 20px;
  }
}

.right-col {
  font-family: AppFont;
  font-size: 10px;
  line-height: 15px;
  text-align: right;
  color: #1a1a18;
}
@media (min-width: 991px) {
  .right-col {
    font-size: 14px;
    line-height: 20px;
  }
}

.border-top-light-blue {
  border-top: 0.5px solid #e2dcd5;
}
.border-top-light-blue h3 {
  margin-top: 10px;
  place-self: center;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
}

ion-chip {
  margin: 0;
  margin-left: auto;
  background: var(--ion-color-primary);
  padding: 2px 10px;
  border-radius: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: unset;
  width: -moz-fit-content;
  width: fit-content;
}
ion-chip ion-label {
  font-family: AppFontBold;
  font-size: 9px;
  line-height: 10px;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
}
@media (min-width: 991px) {
  ion-chip ion-label {
    font-size: 12px;
    line-height: 14px;
  }
}

.card-content-md {
  font-weight: unset;
}

.adds-price {
  padding-left: 5px;
  color: var(--ion-color-medium);
}

.order-at-header {
  text-align: left;
  margin: 10px;
  margin-left: 0px;
  font-size: 20px;
  line-height: 24px;
  text-transform: uppercase;
  font-family: AppFontBold, sans-serif;
  font-weight: bold;
  color: var(--ion-color-black);
}

.section-header {
  text-align: left;
  margin: 20px 0 10px 0;
  font-size: 18px;
  line-height: 22px;
  text-transform: uppercase;
  font-weight: bold;
  color: white;
  padding: 10px 0;
}

ion-label {
  text-align: left;
}

.padding {
  padding: 25px;
}

.icon-edit {
  zoom: 2;
}

.privacy {
  font-family: OpenSans, sans-serif;
  font-size: 11px;
  color: var(--ion-color-black);
}

.phoneCountry {
  max-width: 15%;
}
@media (min-width: 991px) {
  .phoneCountry {
    max-width: 10%;
  }
}

ion-card-title {
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  color: var(--ion-color-black);
  font-size: 18px;
}

.separator {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.separator .line {
  height: 8px;
  background-image: url('dot.svg');
  background-size: 7px 100%;
}
.separator--wide .line {
  background-size: 8px 100%;
}

.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: 10px 17px;
}

.button-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 12px;
  margin-bottom: 10px;
}
.button-row .footer-btn {
  min-height: 46px;
  height: 46px;
  width: 75%;
  --padding-start: 5px;
  --padding-end: 5px;
  --padding-top: 5px;
  --padding-bottom: 5px;
  position: relative;
}
.button-row .footer-btn.hide {
  opacity: 0;
  pointer-events: none;
}
.button-row .footer-btn .footer-btn-text {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 14px;
  margin: 0 auto;
  color: #fff;
}
.button-row .footer-btn .button-img {
  width: 35px;
  height: 35px;
  display: inline-block;
  margin-left: 5px;
}
.button-row .button-total {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: min-content;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  margin-left: auto;
  text-align: right;
  color: #000;
  text-transform: uppercase;
}
.button-row .button-total span {
  font-family: AppFontBold;
  font-size: 18px;
  color: #000;
}

.elternative-button-row {
  margin-bottom: 10px;
}
.elternative-button-row ion-button {
  width: 100%;
  min-height: 45px;
}

.footer-info-title {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 19px;
}

ion-radio-group {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;
  margin-left: 0;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  color: #000;
}
@media (max-width: 992px) {
  ion-radio-group {
    width: auto;
    margin-left: 0;
    line-break: auto;
    max-width: 100%;
  }
}
ion-radio-group ion-radio {
  --border-width: 1px;
  --border-color: #000;
  --border-color-checked: #000;
  --background-checked: transparent;
  --color-checked: #000;
  --color: #000;
  margin-left: 0;
  padding-left: 0;
}
ion-radio-group ion-radio::part(label) {
  text-overflow: initial;
  white-space: initial;
  word-break: normal;
  overflow-wrap: normal;
  text-align: left !important;
  justify-content: flex-start !important;
  margin-left: 0;
  padding-left: 8px;
}
ion-radio-group .radio-checked::part(mark) {
  transform: scale3d(1.4, 1.4, 1);
}
ion-radio-group .additional-info {
  display: block;
  margin-top: 12px;
  font-family: AppFont;
  font-size: 10px;
  line-height: 13px;
  text-align: left;
  color: #1a1a18;
  word-wrap: break-word;
  overflow-wrap: break-word;
  -webkit-hyphens: auto;
          hyphens: auto;
  white-space: normal;
  max-width: 100%;
}

.main-overview-row {
  padding: 16px 25px;
}

.articles-row ~ :not(.tip-row) {
  margin-bottom: 12px;
}

.tip-row {
  margin-bottom: 12px;
}

app-tip {
  display: block;
  margin-bottom: 12px;
}

.article-row {
  margin-bottom: 8px;
}

.name-col {
  font-family: AppFontBold;
  font-size: 13px;
  line-height: 16px;
  text-align: left;
  color: #000;
}
@media (min-width: 991px) {
  .name-col {
    font-size: 16px;
    line-height: 20px;
  }
}

.article-price {
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 15px;
  text-align: right;
  color: #000;
}
@media (min-width: 991px) {
  .article-price {
    font-size: 14px;
    line-height: 20px;
  }
}

.total-row {
  margin-top: 20px;
}
.total-row .total-title {
  font-family: AppFontBold;
  font-size: 13px;
  line-height: 16px;
  text-align: left;
  color: #000;
  margin: 0;
  text-transform: uppercase;
}
@media (min-width: 991px) {
  .total-row .total-title {
    font-size: 16px;
    line-height: 20px;
  }
}
.total-row .price {
  font-family: AppFontBold;
  font-size: 15px;
  line-height: 15px;
  text-align: right;
  color-scheme: #000;
  margin: 0;
}
@media (min-width: 991px) {
  .total-row .price {
    font-size: 16px;
    line-height: 20px;
  }
}

.wrapper-send-letter {
  display: flex;
  flex-direction: column;
  background: white;
  padding: 10px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  word-wrap: break-word;
}

.consent-link {
  color: inherit;
  text-decoration: underline;
  margin: 0 2px;
  pointer-events: auto;
  position: relative;
  z-index: 2;
}

.container {
  position: relative;
  margin-bottom: 20px;
}
.container ion-label {
  background: white;
  z-index: 999;
  left: 10px;
  padding: 0px 4px;
  font-size: 11px;
  color: #6b6b6b;
}

.input-error {
  --color: red;
  --placeholder-color: red;
  margin-bottom: 0 !important;
}

.error-text {
  margin: 4px 0;
  width: 100%;
  color: red;
  font-size: x-small;
}

.input_group-1 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.input_group-1 .lock-icon {
  height: 12px;
}
@media (min-width: 991px) {
  .input_group-1 .lock-icon {
    margin: 2px -10px 15px 5px;
  }
}
.input_group-1--1 {
  width: 70% !important;
  margin-right: 0;
}
.input_group-1--2 {
  margin: 0px 7px 20px;
  width: 30% !important;
}

.input_group-2 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
}
.input_group-2 .lock-icon {
  height: 12px;
}
@media (min-width: 991px) {
  .input_group-2 .lock-icon {
    margin: 2px -10px 15px 5px;
  }
}
.input_group-2--1 {
  width: 30%;
  margin-right: 0;
}
.input_group-2--2 {
  width: 70%;
  margin: 0 7px 20px;
}

.option-name ion-col {
  font-size: 12px !important;
}

.stacked {
  position: relative;
  top: 10px;
  left: 10px;
  z-index: 2;
  background: #fff;
  padding-inline: 5px;
  width: -moz-fit-content;
  width: fit-content;
}

.separator_white_wrapper {
  width: 100%;
  padding: 20px 25px;
}
.separator_white_wrapper .separator_white {
  height: 14px;
  width: 100%;
  background: url('separator_doted_white.svg') no-repeat center center/100% 100%;
}

.amici-club {
  width: 100%;
  padding: 5px 7px 15px;
}
.amici-club_main {
  display: flex;
}
.amici-club_main .text-content {
  width: 40%;
  display: flex;
  flex-direction: column;
}
.amici-club_main h4 {
  height: 18px;
  font-weight: 700;
  margin-bottom: 8px;
}
.amici-club_main span {
  font-size: 11px;
  color: var(--ion-color-dark);
  line-height: 1;
}
.amici-club_main img {
  margin-right: 14px;
}
.amici-club_main .points {
  margin-left: auto;
  position: relative;
  width: 54px;
  height: 54px;
}
.amici-club_main .points img {
  position: absolute;
  width: 100%;
  height: 100%;
}
.amici-club_main .points span {
  position: absolute;
  left: 50%;
  font-family: AppFontBold;
  font-size: 15px;
  top: 50%;
  transform: translate(-50%, -60%);
}
.amici-club_footer {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.amici-club_footer ion-button {
  width: 47%;
  min-height: 37px;
  height: 37px;
}
.amici-club_footer ion-button:last-child {
  --background: white;
  color: var(--ion-color-primary);
  --border-color: var(--ion-color-primary);
}

@keyframes shakeFade {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  25% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  75% {
    transform: translateX(-5px);
  }
  100% {
    transform: translateX(0);
    opacity: 0;
  }
}
@keyframes pulseColor {
  0% {
    color: var(--ion-color-primary);
  }
  30% {
    color: black;
  }
  60% {
    color: var(--ion-color-danger);
  }
  100% {
    color: var(--ion-color-primary);
  }
}
.lighting {
  animation: pulseColor 1s infinite alternate, shakeFade 1.4s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/app/components/checkout-modal/checkout-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;AADD;;AAIA;EACC,WAAA;AADD;;AAGA;EACC,YAAA;AAAD;;AAEA;EACC,gBAAA;AACD;;AACA;EACC,sBAAA;EACA,uBAAA;AAED;;AACA;EACC,cAAA;AAED;;AACA;EACC,sBAAA;EACA,aAAA;AAED;AADC;EACC,cAAA;EACA,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAGF;;ACnCE;EDmCF;IAEE,WAAA;EAGA;AACF;;AADA;EACC,sBAAA;EACA,kBAAA;AAID;;AAFA;EACC,sBAAA;EAEA,aAAA;EACA,sBAAA;AAID;AAHC;EACC,uBAAA;AAKF;;AADA;EACC,yCAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAID;;AADA;EACC,YAAA;AAID;AAHC;EACC,kBAAA;AAKF;AAHC;EACC,kBAAA;EACA,8CAAA;AAKF;;AAFA;EACC,uBAAA;AAKD;;AAHA;EACC,SAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EAEA,+BAAA;EACA,2DAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,wDAAA;AAKD;AAHC;EACC,mBAAA;AAKF;AAFC;EACC,+BAAA;EACA,YAAA;EACA,2BAAA;AAIF;AAHE;EACC,YAAA;AAKH;AAHE;EACC,aAAA;AAKH;AADC;EACC,UAAA;AAGF;;AACA;EACC,iBAAA;EACA,6BAAA;EACA,UAAA;AAED;AAAC;EACC,kBAAA;AAEF;AACC;EACC,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;AACF;;AAGA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;AADD;ACnIE;ED8HF;IAQE,eAAA;IACA,iBAAA;EACA;AACF;;AAEA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EAEA,cAAA;AADD;ACjJE;ED2IF;IASE,eAAA;IACA,iBAAA;EACA;AACF;;AAEA;EACC,+BAAA;AACD;AAAC;EACC,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;AAEF;;AAEA;EACC,SAAA;EACA,iBAAA;EACA,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EAAA,kBAAA;AACD;AACC;EACC,wBAAA;EACA,cAAA;EACA,iBAAA;EAEA,kBAAA;EACA,yBAAA;EACA,WAAA;AAAF;ACtLE;ED+KD;IASE,eAAA;IACA,iBAAA;EAED;AACF;;AAEA;EACC,kBAAA;AACD;;AAEA;EACC,iBAAA;EACA,8BAAA;AACD;;AACA;EACC,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,oCAAA;EACA,iBAAA;EACA,6BAAA;AAED;;AACA;EACC,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AAED;;AAAA;EACC,gBAAA;AAGD;;AAAA;EACC,aAAA;AAGD;;AADA;EACC,OAAA;AAID;;AAFA;EACC,iCAAA;EACA,eAAA;EACA,6BAAA;AAKD;;AAHA;EACC,cAAA;AAMD;AClPE;ED2OF;IAGE,cAAA;EAQA;AACF;;AALA;EACC,oCAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;AAQD;;AALA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAQD;AANC;EACC,WAAA;EACA,gCAAA;EACA,yBAAA;AAQF;AANC;EACC,yBAAA;AAQF;;AAJA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;AAOD;;AAJA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAOD;AALC;EACC,gBAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAOF;AALE;EACC,UAAA;EACA,oBAAA;AAOH;AAJE;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AAMH;AAJE;EACC,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;AAMH;AAFC;EACC,aAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEA,iBAAA;EACA,WAAA;EACA,yBAAA;AAGF;AAFE;EACC,wBAAA;EACA,eAAA;EACA,WAAA;AAIH;;AACA;EACC,mBAAA;AAED;AADC;EACC,WAAA;EACA,gBAAA;AAGF;;AACA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;AAED;;AACA;EACC,aAAA;EACA,2BAAA;EAEA,mBAAA;EACA,cAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;AADD;AC/VE;EDoVF;IAcE,WAAA;IACA,cAAA;IACA,gBAAA;IACA,eAAA;EACA;AACF;AAAC;EACC,mBAAA;EAEA,oBAAA;EACA,4BAAA;EACA,iCAAA;EACA,qBAAA;EACA,aAAA;EAEA,cAAA;EACA,eAAA;AAAF;AAEE;EACC,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,2BAAA;EACA,sCAAA;EACA,cAAA;EACA,iBAAA;AAAH;AAGC;EACC,+BAAA;AADF;AAIC;EACC,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;UAAA,aAAA;EACA,mBAAA;EACA,eAAA;AAFF;;AAMA;EACC,kBAAA;AAHD;;AAMA;EACC,mBAAA;AAHD;;AAMA;EACC,mBAAA;AAHD;;AAMA;EACC,cAAA;EACA,mBAAA;AAHD;;AAMA;EACC,kBAAA;AAHD;;AAMA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;AAJD;AC/aE;ED6aF;IAQE,eAAA;IACA,iBAAA;EAFA;AACF;;AAIA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EACA,WAAA;AAFD;AC7bE;EDybF;IAQE,eAAA;IACA,iBAAA;EAAA;AACF;;AAGA;EACC,gBAAA;AAAD;AAEC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;AAAF;AChdE;EDycD;IASE,eAAA;IACA,iBAAA;EAED;AACF;AACC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,SAAA;AAAF;AC9dE;EDudD;IASE,eAAA;IACA,iBAAA;EAED;AACF;;AAEA;EACC,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;AACD;;AAEA;EACC,cAAA;EACA,0BAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;AACD;;AAEA;EACC,kBAAA;EACA,mBAAA;AACD;AAAC;EAGC,iBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAAF;;AAGA;EACC,YAAA;EACA,wBAAA;EACA,2BAAA;AAAD;;AAGA;EACC,aAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;AAAD;;AAEA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AACD;AAAC;EACC,YAAA;AAEF;AC5hBE;EDyhBD;IAGE,0BAAA;EAID;AACF;AAFC;EACC,qBAAA;EACA,eAAA;AAIF;AAFC;EACC,oBAAA;EACA,qBAAA;AAIF;;AAAA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAGD;AADC;EACC,YAAA;AAGF;ACnjBE;ED+iBD;IAGE,0BAAA;EAKD;AACF;AACC;EACC,UAAA;EACA,eAAA;AACF;AAEC;EACC,UAAA;EACA,kBAAA;AAAF;;AAKC;EACC,0BAAA;AAFF;;AAMA;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;AAHD;;AAKA;EACC,WAAA;EACA,kBAAA;AAFD;AAGC;EACC,YAAA;EACA,WAAA;EACA,8EAAA;AADF;;AAKA;EACC,WAAA;EACA,qBAAA;AAFD;AAIC;EACC,aAAA;AAFF;AAGE;EACC,UAAA;EACA,aAAA;EACA,sBAAA;AADH;AAGE;EACC,YAAA;EACA,gBAAA;EACA,kBAAA;AADH;AAGE;EACC,eAAA;EACA,4BAAA;EACA,cAAA;AADH;AAGE;EACC,kBAAA;AADH;AAIE;EACC,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAFH;AAGG;EACC,kBAAA;EACA,WAAA;EACA,YAAA;AADJ;AAGG;EACC,kBAAA;EACA,SAAA;EACA,wBAAA;EACA,eAAA;EACA,QAAA;EACA,gCAAA;AADJ;AAOC;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;AALF;AAME;EACC,UAAA;EACA,gBAAA;EACA,YAAA;AAJH;AAME;EACC,mBAAA;EACA,+BAAA;EACA,wCAAA;AAJH;;AASA;EACC;IACC,wBAAA;IACA,UAAA;EANA;EAQD;IACC,2BAAA;EANA;EAQD;IACC,0BAAA;EANA;EAQD;IACC,2BAAA;EANA;EAQD;IACC,wBAAA;IACA,UAAA;EANA;AACF;AAQA;EACC;IACC,+BAAA;EANA;EAQD;IACC,YAAA;EANA;EAQD;IACC,8BAAA;EANA;EAQD;IACC,+BAAA;EANA;AACF;AAQA;EACC,uEAAA;AAND","sourcesContent":["@import '../../../theme/mixins';\n\n:root {\n\t--ion-padding: 12px;\n}\n\n.full-width {\n\twidth: 100%;\n}\nswiper-container {\n\theight: 100%;\n}\n.margin-top-value {\n\tmargin-top: 10px;\n}\nion-slides {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\nswiper-slide {\n\toverflow: auto;\n}\n\nion-slide {\n\twidth: 100% !important;\n\tpadding: 10px;\n\t> ion-col {\n\t\toverflow: auto;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tposition: absolute;\n\t\tpadding: 20px;\n\t\ttext-align: left;\n\t}\n}\nion-content {\n\t@include desktop {\n\t\theight: 80%;\n\t}\n}\n.form-row {\n\tpadding: 5px 25px 20px;\n\toverflow-x: hidden;\n}\n.slots-row {\n\tpadding: 5px 25px 20px;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\th2 {\n\t\tcolor: white !important;\n\t}\n}\n\n.form-card {\n\tbackground-color: var(--background-color);\n\tpadding: 12px 6px;\n\tmargin-top: 20px;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.phone-item {\n\tborder: none;\n\tion-input:first-child {\n\t\tmargin-right: 10px;\n\t}\n\tion-input {\n\t\tmargin-bottom: 5px;\n\t\tborder-bottom: 1px solid var(--ion-color-dark);\n\t}\n}\n.label-error {\n\tcolor: rgb(119, 25, 25);\n}\nion-card {\n\tmargin: 0;\n\tpadding: 12px;\n\tborder-radius: 0px;\n\ttext-align: initial;\n\n\t--color: var(--ion-color-black);\n\t--preorder-type-chip-border-color: var(--ion-color-primary);\n\toverflow: auto;\n\tword-break: break-word;\n\tborder: 0.5px solid #e2dcd5;\n\tbox-shadow: 0px 0px 35px 0px #0000000f;\n\n\t&:first-of-type {\n\t\tmargin-bottom: 10px;\n\t}\n\n\tion-card-content {\n\t\tborder-top: 0.5px solid #e2dcd5;\n\t\tpadding: 0px;\n\t\tline-break: auto !important;\n\t\t&:first-of-type {\n\t\t\tborder: none;\n\t\t}\n\t\t.padding-card {\n\t\t\tpadding: 10px;\n\t\t}\n\t}\n\n\tion-col {\n\t\tpadding: 0;\n\t}\n}\n\nion-card-header {\n\tbackground: white;\n\tcolor: var(--ion-color-black);\n\tpadding: 0;\n\n\t.separator {\n\t\tmargin-block: 20px;\n\t}\n\n\tion-button {\n\t\t--background: transparent;\n\t\t--color: #54504c;\n\t\tborder: 1.5px solid white;\n\t\ttext-transform: none;\n\t}\n}\n\n.left-col {\n\tfont-family: AppFontBold;\n\tfont-size: 13px;\n\tline-height: 16px;\n\n\ttext-align: left;\n\tcolor: #000;\n\t@include desktop {\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t}\n}\n\n.right-col {\n\tfont-family: AppFont;\n\tfont-size: 10px;\n\tline-height: 15px;\n\n\ttext-align: right;\n\n\tcolor: #1a1a18;\n\t@include desktop {\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t}\n}\n\n.border-top-light-blue {\n\tborder-top: 0.5px solid #e2dcd5;\n\th3 {\n\t\tmargin-top: 10px;\n\t\tplace-self: center;\n\t\tfont-size: 16px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t}\n}\n\nion-chip {\n\tmargin: 0;\n\tmargin-left: auto;\n\tbackground: var(--ion-color-primary);\n\tpadding: 2px 10px;\n\tborder-radius: 28px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmin-height: unset;\n\twidth: fit-content;\n\n\tion-label {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 9px;\n\t\tline-height: 10px;\n\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tcolor: #fff;\n\t\t@include desktop {\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 14px;\n\t\t}\n\t}\n}\n\n.card-content-md {\n\tfont-weight: unset;\n}\n\n.adds-price {\n\tpadding-left: 5px;\n\tcolor: var(--ion-color-medium);\n}\n.order-at-header {\n\ttext-align: left;\n\tmargin: 10px;\n\tmargin-left: 0px;\n\tfont-size: 20px;\n\tline-height: 24px;\n\ttext-transform: uppercase;\n\tfont-family: AppFontBold, sans-serif;\n\tfont-weight: bold;\n\tcolor: var(--ion-color-black);\n}\n\n.section-header {\n\ttext-align: left;\n\tmargin: 20px 0 10px 0;\n\tfont-size: 18px;\n\tline-height: 22px;\n\ttext-transform: uppercase;\n\tfont-weight: bold;\n\tcolor: white;\n\tpadding: 10px 0;\n}\nion-label {\n\ttext-align: left;\n}\n\n.padding {\n\tpadding: 25px;\n}\n.icon-edit {\n\tzoom: 2;\n}\n.privacy {\n\tfont-family: OpenSans, sans-serif;\n\tfont-size: 11px;\n\tcolor: var(--ion-color-black);\n}\n.phoneCountry {\n\tmax-width: 15%;\n\t@include desktop {\n\t\tmax-width: 10%;\n\t}\n}\n\nion-card-title {\n\tfont-family: AppFontBold, sans-serif;\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-black);\n\tfont-size: 18px;\n}\n\n.separator {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\n\t.line {\n\t\theight: 8px;\n\t\tbackground-image: url(../../../assets/losteria/dot.svg);\n\t\tbackground-size: 7px 100%;\n\t}\n\t&--wide .line {\n\t\tbackground-size: 8px 100%;\n\t}\n}\n\n.footer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: stretch;\n\tpadding: 10px 17px;\n}\n\n.button-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tflex-wrap: wrap;\n\tmargin-top: 12px;\n\tmargin-bottom: 10px;\n\n\t.footer-btn {\n\t\tmin-height: 46px;\n\t\theight: 46px;\n\t\twidth: 75%;\n\t\t--padding-start: 5px;\n\t\t--padding-end: 5px;\n\t\t--padding-top: 5px;\n\t\t--padding-bottom: 5px;\n\t\tposition: relative;\n\n\t\t&.hide {\n\t\t\topacity: 0;\n\t\t\tpointer-events: none;\n\t\t}\n\n\t\t.footer-btn-text {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 14px;\n\t\t\tmargin: 0 auto;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.button-img {\n\t\t\twidth: 35px;\n\t\t\theight: 35px;\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-left: 5px;\n\t\t}\n\t}\n\n\t.button-total {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tjustify-content: flex-end;\n\t\twidth: min-content;\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\t\tmargin-left: auto;\n\n\t\ttext-align: right;\n\t\tcolor: #000;\n\t\ttext-transform: uppercase;\n\t\tspan {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 18px;\n\t\t\tcolor: #000;\n\t\t}\n\t}\n}\n\n.elternative-button-row {\n\tmargin-bottom: 10px;\n\tion-button {\n\t\twidth: 100%;\n\t\tmin-height: 45px;\n\t}\n}\n\n.footer-info-title {\n\tfont-family: AppFontBold;\n\tfont-size: 16px;\n\tline-height: 19px;\n}\n\nion-radio-group {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\n\tmargin-bottom: 12px;\n\tmargin-left: 0;\n\n\tfont-family: AppFontBold;\n\tfont-size: 14px;\n\tline-height: 17px;\n\n\ttext-align: left;\n\tcolor: #000;\n\t@include mobile {\n\t\twidth: auto;\n\t\tmargin-left: 0;\n\t\tline-break: auto;\n\t\tmax-width: 100%;\n\t}\n\tion-radio {\n\t\t--border-width: 1px;\n\n\t\t--border-color: #000;\n\t\t--border-color-checked: #000;\n\t\t--background-checked: transparent;\n\t\t--color-checked: #000;\n\t\t--color: #000;\n\t\t\n\t\tmargin-left: 0;\n\t\tpadding-left: 0;\n\n\t\t&::part(label) {\n\t\t\ttext-overflow: initial;\n\t\t\twhite-space: initial;\n\t\t\tword-break: normal;\n\t\t\toverflow-wrap: normal;\n\t\t\ttext-align: left !important;\n\t\t\tjustify-content: flex-start !important;\n\t\t\tmargin-left: 0;\n\t\t\tpadding-left: 8px;\n\t\t}\n\t}\n\t.radio-checked::part(mark) {\n\t\ttransform: scale3d(1.4, 1.4, 1);\n\t}\n\n\t.additional-info {\n\t\tdisplay: block;\n\t\tmargin-top: 12px;\n\t\tfont-family: AppFont;\n\t\tfont-size: 10px;\n\t\tline-height: 13px;\n\t\ttext-align: left;\n\t\tcolor: #1a1a18;\n\t\tword-wrap: break-word;\n\t\toverflow-wrap: break-word;\n\t\thyphens: auto;\n\t\twhite-space: normal;\n\t\tmax-width: 100%;\n\t}\n}\n\n.main-overview-row {\n\tpadding: 16px 25px;\n}\n\n.articles-row ~ :not(.tip-row) {\n\tmargin-bottom: 12px;\n}\n\n.tip-row {\n\tmargin-bottom: 12px;\n}\n\napp-tip {\n\tdisplay: block;\n\tmargin-bottom: 12px;\n}\n\n.article-row {\n\tmargin-bottom: 8px;\n}\n\n.name-col {\n\tfont-family: AppFontBold;\n\tfont-size: 13px;\n\tline-height: 16px;\n\n\ttext-align: left;\n\tcolor: #000;\n\t@include desktop {\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t}\n}\n.article-price {\n\tfont-family: AppFontBold;\n\tfont-size: 12px;\n\tline-height: 15px;\n\n\ttext-align: right;\n\tcolor: #000;\n\t@include desktop {\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t}\n}\n\n.total-row {\n\tmargin-top: 20px;\n\n\t.total-title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 13px;\n\t\tline-height: 16px;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\tmargin: 0;\n\t\ttext-transform: uppercase;\n\t\t@include desktop {\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 20px;\n\t\t}\n\t}\n\n\t.price {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 15px;\n\t\tline-height: 15px;\n\n\t\ttext-align: right;\n\t\tcolor-scheme: #000;\n\t\tmargin: 0;\n\t\t@include desktop {\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 20px;\n\t\t}\n\t}\n}\n\n.wrapper-send-letter {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground: white;\n\tpadding: 10px;\n\twidth: 100%;\n\tmax-width: 100%;\n\tbox-sizing: border-box;\n\toverflow-x: hidden;\n\tword-wrap: break-word;\n}\n\n.consent-link {\n\tcolor: inherit;\n\ttext-decoration: underline;\n\tmargin: 0 2px;\n\tpointer-events: auto;\n\tposition: relative;\n\tz-index: 2;\n}\n\n.container {\n\tposition: relative;\n\tmargin-bottom: 20px;\n\tion-label {\n\t\t//   position: absolute;\n\t\t//   top: -7px;\n\t\tbackground: white;\n\t\tz-index: 999;\n\t\tleft: 10px;\n\t\tpadding: 0px 4px;\n\t\tfont-size: 11px;\n\t\tcolor: #6b6b6b;\n\t}\n}\n.input-error {\n\t--color: red;\n\t--placeholder-color: red;\n\tmargin-bottom: 0 !important;\n}\n\n.error-text {\n\tmargin: 4px 0;\n\twidth: 100%;\n\tcolor: red;\n\tfont-size: x-small;\n}\n.input_group-1 {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t.lock-icon {\n\t\theight: 12px;\n\t\t@include desktop {\n\t\t\tmargin: 2px -10px 15px 5px;\n\t\t}\n\t}\n\t&--1 {\n\t\twidth: 70% !important;\n\t\tmargin-right: 0;\n\t}\n\t&--2 {\n\t\tmargin: 0px 7px 20px;\n\t\twidth: 30% !important;\n\t}\n}\n\n.input_group-2 {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 0 12px;\n\n\t.lock-icon {\n\t\theight: 12px;\n\t\t@include desktop {\n\t\t\tmargin: 2px -10px 15px 5px;\n\t\t}\n\t}\n\n\t.container {\n\t}\n\n\t&--1 {\n\t\twidth: 30%;\n\t\tmargin-right: 0;\n\t}\n\n\t&--2 {\n\t\twidth: 70%;\n\t\tmargin: 0 7px 20px;\n\t}\n}\n\n.option-name {\n\tion-col {\n\t\tfont-size: 12px !important;\n\t}\n}\n\n.stacked {\n\tposition: relative;\n\ttop: 10px;\n\tleft: 10px;\n\tz-index: 2;\n\tbackground: #fff;\n\tpadding-inline: 5px;\n\twidth: fit-content;\n}\n.separator_white_wrapper {\n\twidth: 100%;\n\tpadding: 20px 25px;\n\t.separator_white {\n\t\theight: 14px;\n\t\twidth: 100%;\n\t\tbackground: url('../../../assets/icon/separator_doted_white.svg') no-repeat center center/ 100% 100%;\n\t}\n}\n\n.amici-club {\n\twidth: 100%;\n\tpadding: 5px 7px 15px;\n\n\t&_main {\n\t\tdisplay: flex;\n\t\t.text-content {\n\t\t\twidth: 40%;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t}\n\t\th4 {\n\t\t\theight: 18px;\n\t\t\tfont-weight: 700;\n\t\t\tmargin-bottom: 8px;\n\t\t}\n\t\tspan {\n\t\t\tfont-size: 11px;\n\t\t\tcolor: var(--ion-color-dark);\n\t\t\tline-height: 1;\n\t\t}\n\t\timg {\n\t\t\tmargin-right: 14px;\n\t\t}\n\n\t\t.points {\n\t\t\tmargin-left: auto;\n\t\t\tposition: relative;\n\t\t\twidth: 54px;\n\t\t\theight: 54px;\n\t\t\timg {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t\tspan {\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 50%;\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 15px;\n\t\t\t\ttop: 50%;\n\t\t\t\ttransform: translate(-50%, -60%);\n\t\t\t}\n\t\t}\n\n\n\t}\n\t&_footer {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-top: 15px;\n\t\tion-button {\n\t\t\twidth: 47%;\n\t\t\tmin-height: 37px;\n\t\t\theight: 37px;\n\t\t}\n\t\tion-button:last-child {\n\t\t\t--background: white;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t\t--border-color: var(--ion-color-primary);\n\t\t}\n\t}\n}\n\n@keyframes shakeFade {\n\t0% {\n\t\ttransform: translateX(0);\n\t\topacity: 1;\n\t}\n\t25% {\n\t\ttransform: translateX(-5px);\n\t}\n\t50% {\n\t\ttransform: translateX(5px);\n\t}\n\t75% {\n\t\ttransform: translateX(-5px);\n\t}\n\t100% {\n\t\ttransform: translateX(0);\n\t\topacity: 0;\n\t}\n}\n@keyframes pulseColor {\n\t0% {\n\t\tcolor: var(--ion-color-primary);\n\t}\n\t30% {\n\t\tcolor: black;\n\t}\n\t60% {\n\t\tcolor: var(--ion-color-danger);\n\t}\n\t100% {\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n.lighting {\n\tanimation: pulseColor 1s infinite alternate, shakeFade 1.4s ease-in-out;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
